module.exports = __webpack_public_path__ + "media/images/web/favicon/ms-icon-144x144-8185d06be2ab6d37117e08f030ec724c.png";